import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'

// 导入SVG图标
import './icons'

// 导入样式
import './style/common.scss'
import './style/fonts.scss'

Vue.config.productionTip = false

// 使用Vant
Vue.use(Vant)

// 配置axios
Vue.prototype.$http = axios

// 添加移动端适配
import 'amfe-flexible'

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
